import * as tokenService from './tokenService'
const BASE_URL = '/Account'

export const changePassword = async (credentials) => {
    try {
        const res = await fetch(`${BASE_URL}/ChangePassword`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
                Authorization: `Bearer ${tokenService.getToken()}`
            }),
            body: JSON.stringify(credentials),
        })
        const json = await res.json()
        if (json.token) {
            tokenService.removeToken()
            tokenService.setToken(json.token)
        }
        if (json.err) {
            throw new Error(json.err)
        }
    } catch (err) {
        throw err
    }
}

export const getAccountSettings = async () => {
    const token = tokenService.getToken()
    try {
        const res = await fetch(`${BASE_URL}/RetrieveAccountSettings`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        })
        return await res.json()
    } catch (error) {
        throw error
    }
}

export const getAccountByUsername = async (username) => {
    const token = tokenService.getToken()
    try {
        const res = await fetch(`${BASE_URL}/RetrieveAccountByUsername?username=` + username, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        })
        if (res.status === 204) {
            return null
        }
        else if (res.status === 200) {
            return await res.json()
        }
        else {
            return null
        }
    } catch (error) {
        throw error
    }
}

export const getAccountById = async (id) => {
    const token = tokenService.getToken()
    try {
        const res = await fetch(`${BASE_URL}/RetrieveAccount?id=` + id, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        })
        if (res.status === 204) {
            return null
        }
        else if (res.status === 200) {
            return await res.json()
        }
        else {
            return null
        }
    } catch (error) {
        throw error
    }
}

export const getExhibitors = async () => {
    const token = tokenService.getToken()
    try {
        const res = await fetch(`${BASE_URL}/RetrieveExhibitors`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        })
        return await res.json()
    } catch (error) {
        throw error
    }
}
export const addUpdateAccount = async (reqBody) => {
    const token = tokenService.getToken()
    try {
        const res = await fetch(`${BASE_URL}/AddUpdateAccount`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(reqBody),
        })
        return await res.json()
    } catch (error) {
        throw error
    }
}

export const getAccountChildren = async (id) => {
    const token = tokenService.getToken()
    try {
        const res = await fetch(`${BASE_URL}/RetrieveChildren?id=` + id, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        })
        if (res.status === 204) {
            return null
        }
        else if (res.status === 200) {
            return await res.json()
        }
    } catch (error) {
        throw error
    }
}

export const activate = async (id) => {
    const token = tokenService.getToken()
    try {
        const res = await fetch(`${BASE_URL}/EnableChild?id=` + id, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        })
        if (res.status === 204) {
            return null
        }
        else if (res.status === 200) {
            return await res.json()
        }
        else {
            return null
        }
    } catch (error) {
        throw error
    }
}
export const deactivate = async (id) => {
    const token = tokenService.getToken()
    try {
        const res = await fetch(`${BASE_URL}/DisableChild?id=` + id, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        })
        if (res.status === 204) {
            return null
        }
        else if (res.status === 200) {
            return await res.json()
        }
        else {
            return null
        }
    } catch (error) {
        throw error
    }
}
export const impersonate = async (reqBody) => {
    let error = new Error();
    const token = tokenService.getToken()
    try {
        const res = await fetch(`${BASE_URL}/Impersonate`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(reqBody),
        })
        const json = await res.json()
        //console.log(json)
        if (json.errors) {
            // create own object to pass errors correctly
            Object.assign(error, { internalError: json.errors });
            throw error;
        }
        if (json.token) {
            tokenService.setToken(json.token)
        }
    } catch (error) {
        throw error
    }
}
export const stopImpersonate = async () => {
    let error = new Error();
    const token = tokenService.getToken()
    try {
        const res = await fetch(`${BASE_URL}/StopImpersonate`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
        })
        const json = await res.json()
        //console.log(json)
        if (json.errors) {
            // create own object to pass errors correctly
            Object.assign(error, { internalError: json.errors });
            throw error;
        }
        if (json.token) {
            tokenService.setToken(json.token)
        }
    } catch (error) {
        throw error
    }
}